import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
// How to use external JS files and JavaScript code in Angular 6/7 h
// https://www.truecodex.com/course/angular-6/how-to-use-external-js-files-and-javascript-code-in-angular
// [25 HTML Funny 404 Pages](https://freefrontend.com/html-funny-404-pages/)
// 404 Error Page Smoke From Toaster https://codepen.io/wikyware-net/pen/xywexE
declare const $: any;

@Component({
  selector: 'app-page-not-found-component',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.css']
})

export class PageNotFoundComponent implements AfterViewInit, OnInit {

  constructor(private router: Router) { }

  ngAfterViewInit(): void {
    const self = this;

    setTimeout(() => {
      self.router.navigateByUrl('/home');
    }, 10000);
  }

  ngOnInit(): void {
    $(() => {
      alert('Hello, page not found');
    });
  }

}
